import React from 'react';
import { Stack, Typography, colors } from '@mui/material';
import { PaylinkCustomerInfo } from 'skipify-types';
import { Email, Textsms } from '@mui/icons-material';

import { phone as phoneFormatter } from '../../../../util/formatters';

type Props = Pick<PaylinkCustomerInfo, 'firstName' | 'lastName' | 'email' | 'phone'>;

export const CustomerSummary = React.memo(({ firstName, lastName, email, phone }: Props) => (
  <Stack>
    <Typography
      sx={{
        fontSize: 12,
        color: colors.grey[600],
        fontWeight: 600,
      }}
    >
      Customer
    </Typography>
    <Stack
      sx={{
        '& p': {
          fontSize: 14,
          fontWeight: 400,
          color: colors.grey[900],
        },
      }}
    >
      {firstName && <Typography>{`${firstName} ${lastName}`}</Typography>}
      {email && (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Email sx={{ fontSize: 14 }} />
          <Typography>{email}</Typography>
        </Stack>
      )}
      {phone && (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Textsms sx={{ fontSize: 14 }} />
          <Typography>{phoneFormatter(phone)}</Typography>
        </Stack>
      )}
    </Stack>
  </Stack>
));

CustomerSummary.displayName = 'CustomerSummary';
